import * as Sentry from '@sentry/vue'
import Vue from 'vue'
import Router from 'vue-router'
import store from './store/modules/moduleMessages'

import { useDadosHistoricosStore } from './store/modules/moduleDadosHistoricos'
const dadosHistoricosStore = useDadosHistoricosStore()

import Login from './views/Login/Login'
import Main from './views/Main/Main'
import PoliticaDePrivacidade from './views/PoliticaDePrivacidade/PoliticaDePrivacidade.vue'
import RecuperarSenha from './views/RecuperarSenha/RecuperarSenha'

/**
 * Home
 */
import Analise from './views/Dashboard/Analise/Analise.vue'
import AnaliseDetalhada from './views/Dashboard/AnaliseDetalhada'
import Dashboard from './views/Dashboard/Dashboard'
import Indicadores from './views/Dashboard/Indicadores/Indicadores.vue'
import Mapa from './views/Dashboard/Mapa/Mapa.vue'

/**
 * Cadastros / Florestal
 */
import CadastroFlorestal from './views/Cadastros/Florestal/CadastroFlorestal'
import Especie from './views/Cadastros/Florestal/Especie/Especie'
import Fazenda from './views/Cadastros/Florestal/Fazenda/Fazenda.vue'
import MaterialGenetico from './views/Cadastros/Florestal/MaterialGenetico/MaterialGenetico'
import Plantio from './views/Cadastros/Florestal/Plantio/Plantio'
import Solo from './views/Cadastros/Florestal/Solo/Solo'
import Talhao from './views/Cadastros/Florestal/Talhao/Talhao'

/**
 * Cadastros / Inventario
 */
import CadastroInventario from './views/Cadastros/Inventario/CadastroInventario'
import CategoriaDeArvore from './views/Cadastros/Inventario/CategoriaDeArvore/CategoriaDeArvore'
import CategoriaDeFitossanidade from './views/Cadastros/Inventario/CategoriaDeFitossanidade/CategoriaDeFitossanidade'
import EstratoFlorestal from './views/Cadastros/Inventario/EstratoFlorestal/EstratoFlorestal'
import MedicoesCubagem from './views/Cadastros/Inventario/MedicoesCubagem/MedicoesCubagem'
import MedicoesInventario from './views/Cadastros/Inventario/MedicoesInventario/MedicoesInventario'
import Parcela from './views/Cadastros/Inventario/Parcela/Parcela'
import Produto from './views/Cadastros/Inventario/Produto/Produto'

/**
 * Planejamento
 */
import OrdemServico from './pages/planejamento/ordemservico/OrdemServico.vue'
import PlanejarOrdemServico from './pages/planejamento/ordemservico/PlanejarOrdemServico.vue'
import Coletor from './views/Planejamento/Coletor/Coletor'
import CronogramaDeOrdemDeServico from './views/Planejamento/CronogramaDeOrdemDeServico/CronogramaDeOrdemDeServico'
import OrdemDeServico from './views/Planejamento/OrdemDeServico/OrdemDeServico'
import Planejamento from './views/Planejamento/Planejamento'

import PlanejamentoOrdemDeServicoCubagem from './views/Planejamento/OrdemDeServico/PlanejamentoOrdemDeServicoCubagem'

/**
 * Prognose
 */

import Classificacao from './views/Prognose/Classificacao/Classificacao'
import PlanejamentoClassificacao from './views/Prognose/Classificacao/PlanejamentoClassificacao'

import PlanejamentoPrognose from './views/Prognose/Prognose/PlanejamentoPrognose'
import ProcessamentosPrognose from './views/Prognose/Prognose/ProcessamentosPrognose'
import Prognose from './views/Prognose/Prognose/Prognose'

import Previsao from './views/Prognose/Previsao'
import Vincular from './views/Prognose/Vincular/Vincular'

import BaseHistorica from './views/Prognose/BaseHistorica/BaseHistorica.vue'
import ValidarBase from './views/Prognose/BaseHistorica/ValidarBase.vue'

/**
 * Processamentos
 */
import Cubagem from './views/Processamentos/Cubagem/Cubagem.vue'
import InventarioFlorestal from './views/Processamentos/InventarioFlorestal/InventarioFlorestal.vue'
import InventarioPilhas from './views/Processamentos/InventarioPilhas/InventarioPilhas.vue'
import InventarioQualidade from './views/Processamentos/InventarioQualidade/InventarioQualidade.vue'
import Processamentos from './views/Processamentos/Processamentos.vue'

/**
 * Relatórios
 */
import RelatorioInventarioFlorestal from './views/Relatorios/InventarioFlorestal/RelatorioInventarioFlorestal.vue'
import RelatorioInventarioFlorestalQualidade from './views/Relatorios/InventarioFlorestalQualidade/RelatorioInventarioFlorestalQualidade.vue'
import RelatorioOrdemDeServico from './views/Relatorios/OrdemDeServico/OrdemDeServico.vue'
import Relatorios from './views/Relatorios/Relatorios.vue'

/**
 * Exportações
 */
import ExportacaoBetas from './views/Exportacoes/Betas/Betas.vue'
import Exportacoes from './views/Exportacoes/Exportacoes.vue'
import ExportacaoInventarioArvore from './views/Exportacoes/InventarioArvore/InventarioArvore.vue'
import InventarioCompilado from './views/Exportacoes/InventarioCompilado/InventarioCompilado.vue'
import ExportacaoInventarioEstrato from './views/Exportacoes/InventarioEstrato/InventarioEstrato.vue'
import ExportarInventarioParcela from './views/Exportacoes/InventarioParcela/ExportacaoInventarioParcela.vue'
import ExportacaoInventarioPilha from './views/Exportacoes/InventarioPilha/InventarioPilha.vue'
import InventarioQualidadeExportacao from './views/Exportacoes/InventarioQualidadeExportacao/InventarioQualidadeExportacao.vue'
import ExportacaoInventarioSingleTrees from './views/Exportacoes/InventarioSingleTrees/InventarioSingleTrees.vue'
import ExportacaoInventarioTalhao from './views/Exportacoes/InventarioTalhao/InventarioTalhao.vue'
import ExportacaoPrognoseVinculada from './views/Exportacoes/PrognoseVinculada/PrognoseVinculada.vue'

/**
 * Integrações
 */
import IntegracaoDefault from './views/Integracoes/IntegracaoDefault/IntegracaoDefault'
import Integracoes from './views/Integracoes/Integracoes'
import ApiKey from './views/Integracoes/ApiKey/ApiKey.vue'

/**
 * Configurações
 */
import Configuracoes from './views/Configuracoes/Configuracoes.vue'
import ConfiguracoesAplicativo from './views/Configuracoes/ConfiguracoesAplicativo/ConfiguracoesAplicativo.vue'
import PerfilDeAcesso from './views/Configuracoes/PerfilDeAcesso/PerfilDeAcesso.vue'
import Usuarios from './views/Configuracoes/Usuarios/Usuarios.vue'

/**
 * Configurações Novo
 */
import ConfiguracoesCubagem from './pages/configuracoes/aplicativo/ConfiguracoesCubagem.vue'
import ConfiguracoesInventarioFlorestal from './pages/configuracoes/aplicativo/ConfiguracoesInventarioFlorestal.vue'
import ConfiguracoesMedicaoPilha from './pages/configuracoes/aplicativo/ConfiguracoesMedicaoPilha.vue'

/**
 * Ajuda
 */

import i18n from './VueI18n'
import Changelog from './views/Changelog/Changelog.vue'
import DashboardCustomizado from './views/Dashboard/DashboardCustomizado.vue'
import PowerBIView from './views/Dashboard/PowerBI/PowerBIView.vue'
import VisualizarDispersao from './views/Prognose/BaseHistorica/VisualizarDispersao.vue'
import TreeviaAcademy from './views/Ajuda/TreeviaAcademy/TreeviaAcademy.vue'
import Ajuda from './views/Ajuda/Ajuda.vue'

import NotifiedUserPage from './@web/modules/fire-risk-settings/@subpages/notified-user/NotifiedUser.page.vue'
import FireRiskSettingsPage from './@web/modules/fire-risk-settings/FireRiskSettings.page.vue'
import AlertSettingsPage from './@web/modules/fire-risk-settings/@subpages/alert-settings/AlertSettings.page.vue'

import FireRiskDashboardPage from './@web/modules/fire-risk-dashboard/FireRiskDashboard.page.vue'

import ExclusionZonePage from './@web/modules/exclusion-zone/pages/ExclusionZone.page.vue'
import ZonesPage from './@web/modules/exclusion-zone/pages/Zones.page.vue'

Vue.use(Router)

/**
 * Rotas que terão na aplicação
 * @path Rota em si que será acessada
 * @name Nome da rota que será acessada
 * @component Componente que será renderizado ao acessar a rota
 * @children Componentes filhos de uma determinada rota
 * @meta Regras para acessar a rota sendo:
 *  --- guest = Apenas usuarios NÃO autenticados devem acessar
 *  --- requiresAuth = Apenas usuarios autenticados devem acessar
 *  --- is_admin = Apenas administradores devem conseguir acessar
 */

const checkPrognoseModule = (to, from, next) => {
	const userModules = JSON.parse(localStorage.getItem('user-modules'))

	//TODO: Dá pra fazer com que função fique genérica ao passar o nome do módulo como parâmetro
	if (!userModules.includes('PROGNOSE')) {
		store.mutations.mutationShowMessage(store.state, {
			messageTitle: i18n.t('aviso'),
			messageText: i18n.t('avisoSemAcessoAoModulo'),
			messageIcon: 'fas fa-lock',
			messageType: 'warning',
		})
		return false
	} else {
		next()
	}
}

const checkDadoHistoricoModule = (to, from, next) => {
	const userModules = JSON.parse(localStorage.getItem('user-modules'))

	//TODO: Dá pra fazer com que função fique genérica ao passar o nome do módulo como parâmetro
	//! Está como DEFAULT por limitação de back-end, o ideal seria termos uma camada de ACL dedicada
	if (!userModules.includes('DEFAULT') && !userModules.includes('PROGNOSE')) {
		store.mutations.mutationShowMessage(store.state, {
			messageTitle: i18n.t('aviso'),
			messageText: i18n.t('avisoSemAcessoAoModulo'),
			messageIcon: 'fas fa-lock',
			messageType: 'warning',
		})
		return false
	} else {
		next()
	}
}

const checkVisualizarDadosHistoricos = (to, from, next) => {
	if (to.query.id || dadosHistoricosStore.state.medicoesHistoricas.length) {
		next()
	} else {
		store.mutations.mutationShowMessage(store.state, {
			messageTitle: i18n.t('aviso'),
			messageText: i18n.t('requireHistoricalBaseImport'),
			messageIcon: 'fas fa-lock',
			messageType: 'warning',
		})
		next({ name: 'baseHistorica' })
	}
}

const checkValidarDadosHistoricos = (to, from, next) => {
	if (dadosHistoricosStore.state.medicoesHistoricas.length) {
		next()
	} else {
		store.mutations.mutationShowMessage(store.state, {
			messageTitle: i18n.t('aviso'),
			messageText: i18n.t('requireHistoricalBaseImport'),
			messageIcon: 'fas fa-lock',
			messageType: 'warning',
		})
		next({ name: 'baseHistorica' })
	}
}

const checkIntegracoesModule = (to, from, next) => {
	const userModules = JSON.parse(localStorage.getItem('user-modules'))

	//TODO: Dá pra fazer com que função fique genérica ao passar o nome do módulo como parâmetro
	if (!userModules.includes('INTEGRACOES')) {
		store.mutations.mutationShowMessage(store.state, {
			messageTitle: i18n.t('aviso'),
			messageText: i18n.t('avisoSemAcessoAoModulo'),
			messageIcon: 'fas fa-lock',
			messageType: 'warning',
		})
		return false
	} else {
		next()
	}
}

const checkApiKeyModule = (to, from, next) => {
	const userModules = JSON.parse(localStorage.getItem('user-modules'))

	if (!userModules.includes('API_KEY')) {
		store.mutations.mutationShowMessage(store.state, {
			messageTitle: i18n.t('aviso'),
			messageText: i18n.t('avisoSemAcessoAoModulo'),
			messageIcon: 'fas fa-lock',
			messageType: 'warning',
		})
		return false
	} else {
		next()
	}
}

const checkRiscoIncendioModule = (to, from, next) => {
	const userModules = JSON.parse(localStorage.getItem('user-modules'))

	if (!userModules.includes('RISCO_INCENDIO')) {
		store.mutations.mutationShowMessage(store.state, {
			messageTitle: i18n.t('aviso'),
			messageText: i18n.t('avisoSemAcessoAoModulo'),
			messageIcon: 'fas fa-lock',
			messageType: 'warning',
		})
		return false
	} else {
		next()
	}
}

const routes = [
	{ path: '/', redirect: '/login' },
	{ path: '/login', name: 'login', component: Login, meta: { guest: true } },
	{
		path: '/politica-de-privacidade',
		name: 'PoliticaDePrivacidade',
		component: PoliticaDePrivacidade,
	},
	{
		path: '/redefinir-senha',
		name: 'redefinirSenha',
		component: RecuperarSenha,
		props: (route) => ({
			userId: route.query.userId,
			passwordResetToken: route.query.passwordResetToken,
		}),
	},
	{
		path: '/main',
		name: 'main',
		component: Main,
		meta: { requiresAuth: true },
		redirect: { name: 'dashboard' },
		children: [
			{ path: '/dashboard', name: 'dashboard', component: Dashboard },
			{
				path: '/analiseDetalhada',
				name: 'analiseDetalhada',
				component: AnaliseDetalhada,
				redirect: { name: 'analise' },
				children: [
					{ path: '/analise', name: 'analise', component: Analise },
					{ path: '/indicadores', name: 'indicadores', component: Indicadores },
					{ path: '/mapa', name: 'mapa', component: Mapa },
				],
			},
			{
				path: '/dashboardCustomizado/:nome?',
				name: 'dashboardCustomizado',
				component: DashboardCustomizado,
			},
			{
				path: '/dashboardPowerBI',
				name: 'dashboardPowerBI',
				component: PowerBIView,
			},
			{
				path: '/cadastroflorestal',
				name: 'cadastroflorestal',
				component: CadastroFlorestal,
				redirect: { name: 'fazenda' },
				children: [
					{ path: '/fazenda', name: 'fazenda', component: Fazenda },
					{ path: '/talhao', name: 'talhao', component: Talhao },
					{ path: '/plantio', name: 'plantio', component: Plantio },
					{ path: '/especie', name: 'especie', component: Especie },
					{ path: '/solo', name: 'solo', component: Solo },
					{
						path: '/materialGenetico',
						name: 'materialGenetico',
						component: MaterialGenetico,
					},
				],
			},
			{
				path: '/cadastroinventario',
				name: 'cadastroinventario',
				component: CadastroInventario,
				redirect: {
					name: `${i18n.t('registry')} / ${i18n.t('inventory')} / ${i18n.t('treeCategory')}`,
				},
				children: [
					{
						path: '/parcela',
						name: `${i18n.t('registry')} / ${i18n.t('inventory')} / ${i18n.t('plot')}`,
						component: Parcela,
					},
					{
						path: '/estratoflorestal',
						name: `${i18n.t('registry')} / ${i18n.t('inventory')} / ${i18n.t('forestStratification')}`,
						component: EstratoFlorestal,
					},
					{
						path: '/medicoesInventario',
						name: `${i18n.t('registry')} / ${i18n.t('inventory')} / ${i18n.t('measurement')}`,
						component: MedicoesInventario,
					},
					{
						path: '/medicoesCubagem',
						name: `${i18n.t('registry')} / ${i18n.t('inventory')} / ${i18n.t('logging')}`,
						component: MedicoesCubagem,
					},
					{
						path: '/categoriaDeArvore',
						name: `${i18n.t('registry')} / ${i18n.t('inventory')} / ${i18n.t('treeCategory')}`,
						component: CategoriaDeArvore,
					},
					{
						path: '/categoriaDeFitossanidade',
						name: `${i18n.t('registry')} / ${i18n.t('inventory')} / ${i18n.t('fitoCategory')}`,
						component: CategoriaDeFitossanidade,
					},
					{
						path: '/produto',
						name: `${i18n.t('registry')} / ${i18n.t('inventory')} / ${i18n.t('product')}`,
						component: Produto,
					},
				],
			},
			{
				path: '/planejamento/ordemservico',
				name: 'Ordem de Serviço',
				component: OrdemServico,
			},
			{
				path: '/planejamento/ordemservico/planejar',
				name: 'Planejar Ordem de Serviço',
				component: PlanejarOrdemServico,
			},
			{
				path: '/planejamento',
				name: 'planejamento',
				component: Planejamento,
				children: [
					{
						path: '/ordemdeservico',
						name: 'ordemdeservico',
						component: OrdemDeServico,
					},
					{
						path: '/ordemservico',
						name: 'ordemservico',
						component: OrdemServico,
					},
					{ path: '/coletor', name: 'coletor', component: Coletor },
					{
						path: '/cronogramadeordemdeservico',
						name: 'cronogramadeordemdeservico',
						component: CronogramaDeOrdemDeServico,
					},
				],
			},
			{
				path: '/ordemdeservico/planejamentocubagem',
				name: 'ordemdeservicocubagem',
				component: PlanejamentoOrdemDeServicoCubagem,
			},
			{
				path: '/previsao',
				name: 'previsao',
				component: Previsao,
				children: [
					{
						path: '/classificacao',
						name: 'classificacao',
						component: Classificacao,
						beforeEnter: checkPrognoseModule,
					},
					{
						path: '/prognose',
						name: 'prognose',
						component: Prognose,
						beforeEnter: checkPrognoseModule,
					},
					{
						path: '/vincular',
						name: 'vincular',
						component: Vincular,
						beforeEnter: checkPrognoseModule,
					},
					{
						path: '/baseHistorica',
						name: 'baseHistorica',
						component: BaseHistorica,
						beforeEnter: checkDadoHistoricoModule,
					},
				],
			},
			{
				path: '/baseHistorica/validarBase',
				name: 'validarBase',
				component: ValidarBase,
				beforeEnter: checkValidarDadosHistoricos,
			},
			{
				path: '/baseHistorica/visualizarDispersao',
				name: 'visualizarDispersao',
				component: VisualizarDispersao,
				beforeEnter: checkVisualizarDadosHistoricos,
			},
			{
				path: '/prognose/planejamento/:id',
				name: 'planejamentoPrognose',
				component: PlanejamentoPrognose,
			},
			{
				path: '/prognose/processamentos',
				name: 'processamentosPrognose',
				component: ProcessamentosPrognose,
			},
			{
				path: '/classificacao/planejamento/:id',
				name: 'planejamentoClassificacao',
				component: PlanejamentoClassificacao,
			},
			{
				path: '/processamentos',
				name: 'processamentos',
				component: Processamentos,
				children: [
					{ path: '/cubagem', name: 'cubagem', component: Cubagem },
					{
						path: '/inventarioflorestal',
						name: 'inventarioflorestal',
						component: InventarioFlorestal,
					},
					{
						path: '/inventarioPilhas',
						name: 'inventarioPilhas',
						component: InventarioPilhas,
					},
					{
						path: '/inventarioQualidade',
						name: 'inventarioQualidade',
						component: InventarioQualidade,
					},
				],
			},
			{
				path: '/relatorios',
				name: 'relatorios',
				component: Relatorios,
				children: [
					{
						path: '/relatorioinventarioflorestal',
						name: 'relatorioinventarioflorestal',
						component: RelatorioInventarioFlorestal,
					},
					{
						path: '/relatorioordemdeservico',
						name: 'relatorioordemdeservico',
						component: RelatorioOrdemDeServico,
					},
					{
						path: '/relatorioinventarioflorestalqualidade',
						name: 'relatorioinventarioflorestalqualidade',
						component: RelatorioInventarioFlorestalQualidade,
					},
				],
			},
			{
				path: '/exportarinventarioparcela',
				name: `${i18n.t('exportacaoInventarioParcela')}`,
				component: ExportarInventarioParcela,
			},
			{
				path: '/exportacoes',
				name: 'exportacoes',
				component: Exportacoes,
				children: [
					{
						path: '/exportacaoinventarioarvore',
						name: 'exportacaoinventarioarvore',
						component: ExportacaoInventarioArvore,
					},

					{
						path: '/exportacaoinventariotalhao',
						name: 'exportacaoinventariotalhao',
						component: ExportacaoInventarioTalhao,
					},
					{
						path: '/exportacaoinventarioestrato',
						name: 'exportacaoinventarioestrato',
						component: ExportacaoInventarioEstrato,
					},
					{
						path: '/exportacaoinventariopilha',
						name: 'exportacaoinventariopilha',
						component: ExportacaoInventarioPilha,
					},
					{
						path: '/exportacaoinventariosingletrees',
						name: 'exportacaoinventariosingletrees',
						component: ExportacaoInventarioSingleTrees,
					},
					{
						beforeEnter: checkPrognoseModule,
						path: '/exportacaovinculaprognose',
						name: 'exportacaovinculaprognose',
						component: ExportacaoPrognoseVinculada,
					},
					{
						path: '/exportacaobetas',
						name: 'exportacaobetas',
						component: ExportacaoBetas,
					},
					{
						path: '/inventariocompilado',
						name: 'inventariocompilado',
						component: InventarioCompilado,
					},

					{
						path: '/inventarioqualidadexportacao',
						name: 'inventarioqualidadexportacao',
						component: InventarioQualidadeExportacao,
					},
				],
			},
			{
				path: '/fire-risk',
				name: 'fire-risk-settings',
				redirect: '/fire-risk/alert-settings',
				component: FireRiskSettingsPage,
				beforeEnter: checkRiscoIncendioModule,
				children: [
					{
						path: '/fire-risk/notified-users',
						name: 'Usuários notificados',
						component: NotifiedUserPage,
						beforeEnter: checkRiscoIncendioModule,
						meta: {
							breadcrumb: 'Risco de Incêndio/Configurações/Usuários notificados',
						},
					},
					{
						path: '/fire-risk/alert-settings',
						name: 'Configurações de alerta',
						component: AlertSettingsPage,
						beforeEnter: checkRiscoIncendioModule,
						meta: {
							breadcrumb: 'Risco de Incêndio/Configurações/Configurações de alerta',
						},
					},
				],
			},
			{
				path: '/fire-risk/dashboard',
				name: 'dashboard-fire-risk',
				component: FireRiskDashboardPage,
				beforeEnter: checkRiscoIncendioModule,
			},
			{
				path: '/fire-risk/exclusion-zone',
				name: 'exclusion-zone',
				component: ExclusionZonePage,
				beforeEnter: checkRiscoIncendioModule,
				meta: {
					breadcrumb: 'Risco de Incêndio/Cadastro de Zona de exclusão',
				},
			},
			{
				path: '/fire-risk/exclusion-zone/zones',
				name: 'Zonas',
				component: ZonesPage,
				beforeEnter: checkRiscoIncendioModule,
			},

			{
				path: '/exportarinventarioparcela',
				name: 'exportarinventarioparcela',
				component: ExportarInventarioParcela,
			},
			{
				path: '/configuracoes/aplicativo',
				redirect: '/configuracoes/aplicativo/inventario',
				name: 'configuracoesapp',
			},
			{
				path: '/configuracoes/aplicativo/inventario',
				name: i18n.t('forestInventory'),
				component: ConfiguracoesInventarioFlorestal,
			},
			{
				path: '/configuracoes/aplicativo/cubagem',
				name: i18n.t('logging'),
				component: ConfiguracoesCubagem,
			},
			{
				path: '/configuracoes/aplicativo/pilha',
				name: i18n.t('stackInventory'),
				component: ConfiguracoesMedicaoPilha,
			},

			{
				path: '/configuracoes',
				name: 'configuracoes',
				component: Configuracoes,
				children: [
					{
						path: '/usuarios',
						name: 'usuarios',
						component: Usuarios,
					},
					{
						path: '/perfildeacesso',
						name: 'perfildeacesso',
						component: PerfilDeAcesso,
					},
					{
						path: '/configuracoesaplicativo',
						name: 'configuracoesaplicativo',
						component: ConfiguracoesAplicativo,
					},
				],
			},
			{
				path: '/ajuda',
				name: 'ajuda',
				component: Ajuda,
				children: [
					{
						path: '/treeviaacademy',
						name: 'treeviaacademy',
						component: TreeviaAcademy,
					},
					{
						path: '/changelog',
						name: 'changelog',
						component: Changelog,
					},
				],
			},

			{
				path: '/integracoes',
				name: 'integracoes',
				component: Integracoes,
				children: [
					{
						path: '/integracao-SAP',
						name: 'integracao-SAP',
						component: IntegracaoDefault,
						props: { tituloPagina: `Integrações / SAP` },
						beforeEnter: checkIntegracoesModule,
					},
					{
						path: '/apikey',
						name: 'apikey',
						component: ApiKey,
						beforeEnter: checkApiKeyModule,
					},
				],
			},
		],
	},
]

/**
 * Objeto Router que conterá as informações e configurações da rota
 * @mode Modo de como será usado o Router
 * @routes Rotas que estão configuradas
 */
const router = new Router({
	mode: process.env.IS_ELECTRON ? 'hash' : 'history',
	routes,
})

/**
 * Antes de cada rota faz as verificacoes necessárias para
 * saber se o usuário tem acesso ás rotas que está tentando acessar
 * @to Para onde o usuário deseja ir
 * @from É de onde o usuário está saindo
 * @next É uma função callback que continua a processar a requisicao do usuario
 */
router.beforeEach((to, from, next) => {
	Sentry.setUser({
		email: localStorage.getItem('email'),
		username: localStorage.getItem('username'),
	})

	let requiresAuth = to.matched.some((record) => record.meta.requiresAuth)

	const acquired = Number(localStorage.getItem('acquired-at')) || 0
	const expire_date = new Date(acquired + 86400000)

	const is_expired = new Date().getTime() > expire_date.getTime()

	const not_granted = requiresAuth && is_expired && to.name != 'login'

	if (not_granted) {
		next('/login')
		store.mutations.mutationShowMessage(store.state, {
			messageTitle: 'Aviso',
			messageText: 'Sua seção expirou, faça login novamente',
			messageIcon: 'fas fa-lock',
			messageType: 'warning',
		})
	} else {
		next()
	}
})

export default router
